import api from '@/services/Api';
import { cleanObject } from '@ifac/ui';

const serializeFilter = (filter) => {
  if (filter === null || filter === undefined) {
    return filter;
  }

  if (typeof filter === 'string') {
    return filter;
  }

  return JSON.stringify(filter);
};

class Affiliates {
  /**
   * Fetch all the affiliates
   * @returns {AxiosPromise<any>}
   */
  static get(
    page = 1,
    perPage = 12,
    search = null,
    sortBy = null,
    direction = 'desc',
    filter = null,
    include = [],
  ) {
    page = parseInt(page, 10);
    perPage = parseInt(perPage, 10);

    // Clean up the empty fields being sent
    const params = cleanObject({
      page,
      perPage,
      sortBy,
      direction,
      search,
      filter: serializeFilter(filter),
      include,
    });

    return api.get('/affiliates', {
      params,
    });
  }

  /**
   * Fetch all the affiliates using minimal info
   *
   * @returns {AxiosPromise<any>}
   */
  static getMin(
    page = 1,
    perPage = 12,
    search = null,
    sortBy = null,
    direction = 'desc',
    filter = null,
  ) {
    page = parseInt(page, 10);
    perPage = parseInt(perPage, 10);

    // Clean up the empty fields being sent
    const params = cleanObject({
      page,
      perPage,
      sortBy,
      direction,
      search,
      filter: serializeFilter(filter),
    });

    return api.get('/affiliates-min', {
      params,
    });
  }

  /**
   * Fetch single affiliate
   * @returns {AxiosPromise<any>}
   */
  static show(id) {
    return api.get(`/affiliates/${id}`);
  }

  /**
   * Fetch affiliate merge item
   *
   * @returns {AxiosPromise<any>}
   */
  static showMergeItem(affiliateId, affiliateMergeId) {
    return api.get(`/affiliates/${affiliateId}/merge-item/${affiliateMergeId}`);
  }

  /**
   * Fetch merged affiliate
   * @returns {AxiosPromise<any>}
   */
  static showMerge(selectedAffiliateId, nonSelectedAffiliateId) {
    return api.get(`/affiliates/${selectedAffiliateId}/merge/${nonSelectedAffiliateId}`);
  }

  /**
   * Fetch merged affiliate
   * @returns {AxiosPromise<any>}
   */
  static completeMerge(newAffiliateId) {
    return api.post(`/affiliates/${newAffiliateId}/complete-merge`);
  }

  /**
   * Update a given affiliate
   * @returns {AxiosPromise<any>}
   */
  static update(payload) {
    return api.put(`/affiliates/${payload.id}`, payload);
  }

  /**
   * Delete a given affiliate
   * @returns {AxiosPromise<any>}
   */
  static delete(affiliateId, payload) {
    return api.delete(`/affiliates/${affiliateId}`, {
      data: payload,
    });
  }

  /**
   * request avatar upload
   * @returns {AxiosPromise<any>}
   */
  static avatarUpload(affiliateId, payload) {
    return api.post(`/affiliates/${affiliateId}/avatars`, payload);
  }

  static updateLoginInfo(affiliateId, payload) {
    return api.post(`/affiliates/${affiliateId}/login-info`, payload);
  }

  static createImpersonationTicket(affiliateId) {
    return api.post(`/affiliates/${affiliateId}/impersonation-ticket`);
  }

  /**
   * Fetch single affiliate
   * @returns {AxiosPromise<any>}
   */
  static exportCsv(p) {
    const params = cleanObject({
      ...p,
      filter: serializeFilter(p?.filter),
      page: 1,
      perPage: 1000000,
    });

    // Per-request responseType (do not mutate the shared axios instance).
    return api.get('/affiliates/export/csv', {
      params,
      responseType: 'arraybuffer',
    });
  }
}

export default Affiliates;
